export default "__VITE_PUBLIC_ASSET__99226ef3__"